import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import IndexEdCard from './indexEdCard';
import { styleVariables } from '../common/constants';

const IndexMoreLearning = ({
  editorialBlocks, env, analyticsObject, passRef, id,
}) => (
  <RootElement id={id} ref={passRef} className="panelColor">
    <div className="maxWidth">

      <h3>More ways to learn</h3>
      <Grid container>
        {editorialBlocks?.map((eb) => <Grid item md={12} lg={4}><IndexEdCard env={env} linkSection={analyticsObject.linkSection} edBlock={eb} section="moreLearning" /></Grid>)}
      </Grid>
    </div>
  </RootElement>
);

const RootElement = styled.div`
  background-color: ${styleVariables.backgroundPanelColor};
  padding: 20px 0 90px;
  h1, h2, h3, h4, h5, h6 {
    margin-top: 0px;
  }

  > div > .MuiGrid-root {
    margin-top: 1px;
    > div.MuiGrid-item:first-child{
      padding-left: 0;
    }
  }
  @media only screen and (max-width: 1039px) {
    > div > .MuiGrid-root {
      > div.MuiGrid-item{
        padding-left: 0;
      }
    }
  }
`;

IndexMoreLearning.propTypes = {
  editorialBlocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  env: PropTypes.string.isRequired,
  analyticsObject: PropTypes.shape({
    linkSection: PropTypes.string,
    linkTitle: PropTypes.string,
    secondaryLinkTitle: PropTypes.string,
  }).isRequired,
  passRef: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
};

export default IndexMoreLearning;
